import type { Model } from "@mainion/protocol";

/** A model's name with its price, like "Claude Sonnet 5.5 · $2 in / $10 out per million tokens". */
export function describeModel({ name, price }: Model): string {
    if (!price) return name;
    if (!price.input && !price.output) return `${name} · free`;

    return `${name} · $${price.input} in / $${price.output} out per million tokens`;
}
